import layoutFinanceiro from './layout-financeiro/LayoutFinanceiroConfig';

const FuseLayoutConfigs = {
  layoutFinanceiro,
};

export default FuseLayoutConfigs;
